import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#580100',
      dark: '#3D0000',
      light: '#801515',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#1e1e1e',
      dark: '#B69441',
      light: '#E8C87E',
      contrastText: '#333333',
    },
    text: {
      primary: '#333333',
      secondary: '#666666',
    },
    background: {
      default: '#FFFFFF',
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"Noto Serif", serif',
    h1: {
      fontSize: '3.5rem',
      fontWeight: 600,
      lineHeight: 1.2,
      color: '#580100',
      fontFamily: '"Noto Serif", serif',
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 600,
      lineHeight: 1.3,
      color: '#580100',
      fontFamily: '"Noto Serif", serif',
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 600,
      lineHeight: 1.4,
      color: '#580100',
      fontFamily: '"Noto Serif", serif',
    },
    h4: {
      fontSize: '1.75rem',
      fontWeight: 600,
      lineHeight: 1.4,
      color: '#580100',
      fontFamily: '"Noto Serif", serif',
    },
    h5: {
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: 1.4,
      color: '#580100',
      fontFamily: '"Noto Serif", serif',
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: 1.4,
      color: '#580100',
      fontFamily: '"Noto Serif", serif',
    },
    subtitle1: {
      fontSize: '1.125rem',
      fontWeight: 500,
      lineHeight: 1.5,
      color: '#666666',
      fontFamily: '"Noto Serif", serif',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
      color: '#666666',
      fontFamily: '"Noto Serif", serif',
      fontWeight: 400,
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
      fontSize: '1rem',
      fontFamily: '"Noto Serif", serif',
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#580100',
          boxShadow: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          padding: '12px 24px',
          fontWeight: 500,
          fontFamily: '"Noto Serif", serif',
        },
        contained: {
          backgroundColor: '#580100',
          color: '#FFFFFF',
          '&:hover': {
            backgroundColor: '#3D0000',
          },
        },
        outlined: {
          borderColor: '#D7B15C',
          color: '#580100',
          '&:hover': {
            borderColor: '#B69441',
            backgroundColor: 'rgba(215, 177, 92, 0.08)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          boxShadow: 'none',
          border: '1px solid #E0E0E0',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          '@media (min-width: 1200px)': {
            maxWidth: '1200px',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontFamily: '"Noto Serif", serif',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: '"Noto Serif", serif',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: '"Noto Serif", serif',
        },
      },
    },
  },
});

export default theme;
